import './services.feature';
import './service.user_reminder';
import './services.tracker';
import { EVENT_NAME_FOR_COUPON_CENTER } from '../constants/tracker';
import { USER_REMINDER_TYPE } from '../constants/user_reminder';

const MEMBER_REFERRAL_I18N_MAP = {
  user_credit: 'user_reminder.member_referral.user_credit',
  member_point: 'user_reminder.member_referral.member_point',
};

app.directive('userReminderMobile', [
  'mainConfig',
  'featureService',
  '$filter',
  'userReminderService',
  '$window',
  'trackerService',
  function (
    mainConfig,
    featureService,
    $filter,
    userReminderService,
    $window,
    trackerService,
  ) {
    return {
      restrict: 'E',
      scope: {
        campaignRule: '=',
      },
      templateUrl: require('../../../../../public/themes/v1/default/views/templates.user-reminder-mobile.html'),
      link: function (scope, element) {
        if ($window.innerWidth >= 768) {
          return;
        }

        scope.reminderType = null;
        scope.hasCouponCenterEnhancementPhase1 = featureService.hasFeature(
          'coupon_center_enhancement_phase1',
        );

        const getReminderType = () =>
          userReminderService.getReminderType({
            campaignRule: scope.campaignRule,
          });

        userReminderService.fetchData().finally(() => {
          scope.reminderType = getReminderType();
        });

        scope.getContentText = () => {
          switch (scope.reminderType) {
            case USER_REMINDER_TYPE.MEMBER_REFERRAL:
              return $filter('translate')(
                MEMBER_REFERRAL_I18N_MAP[scope.campaignRule.reward_type],
                { value: scope.campaignRule.reward_value },
              );
            case USER_REMINDER_TYPE.COUPON:
              if (scope.hasCouponCenterEnhancementPhase1)
                return $filter('translate')('user_reminder.coupon.v2.mobile');
              return $filter('translate')(
                mainConfig.currentUser
                  ? 'user_reminder.coupon.member'
                  : 'user_reminder.coupon.guest',
              );
            default:
              return '';
          }
        };

        // tracker
        function invokeTracker(eventType, data = {}) {
          trackerService.track({
            type: eventType,
            data: {
              scope: 'shop',
              event_category: 'CouponCenter',
              ...data,
            },
          });
        }

        function triggerClose() {
          userReminderService.handleClose(scope.reminderType);
          scope.reminderType = getReminderType();
        }

        scope.handleClose = ($event) => {
          $event.stopPropagation();

          triggerClose();

          invokeTracker(
            EVENT_NAME_FOR_COUPON_CENTER.COUPON_CENTER_POP_UP_CLICK,
            {
              click_type: 'coupon_close',
            },
          );
        };

        scope.handleClickActionButton = () => {
          invokeTracker(
            EVENT_NAME_FOR_COUPON_CENTER.COUPON_CENTER_POP_UP_CLICK,
            {
              click_type: 'coupon_get',
            },
          );

          userReminderService.handleAction(scope.reminderType);
          triggerClose();
        };

        // eslint-disable-next-line compat/compat
        const observer = new IntersectionObserver((entries) => {
          if (
            entries[0].isIntersecting &&
            scope.reminderType === USER_REMINDER_TYPE.COUPON
          ) {
            invokeTracker(
              EVENT_NAME_FOR_COUPON_CENTER.COUPON_CENTER_POP_UP_IMPRESSION,
            );
          }
        });

        // to only track when the element is visible
        if (element) {
          observer.observe(element[0]);
        }

        scope.$on('$destroy', () => {
          observer.disconnect();
        });
      },
    };
  },
]);
